module.exports = __webpack_public_path__ + "static/media/bttw3.ff77d684.jpg";